module.exports = __webpack_public_path__ + "assets/img/d2d908901aa4520e207b26e31b1db2b9.png";